import type { ReactNode } from 'react';

export const AxiosInterceptor = ({ children }: { children: ReactNode }) => {
  return <>{children}</>;
};
